import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { colors } from '../../../../constants'
import { Column, Input, Padding } from '../../..'
import { Link } from 'react-router-dom'

const HeaderBar = styled.div`
    background-color: #3672b8;
    color: white;
    padding: 10px;
    text-align: left;
    font-size: 14px;
    height: 60px;
`

const Dismiss = styled.div`
    color: ${colors.bluelighter};
    cursor: pointer;
    font-size: 25px;
    position: absolute;
    top: 3px;
    right: 15px;
    z-index: 5;
`

const AddIcon = styled(FontAwesomeIcon)`
    color: ${colors.bluelighter};
    cursor: pointer;
    margin-left: 5px;
`

const SearchBoxContainer = styled.div`
    width: 100%;
    text-align: right;
`

const Suggestions = styled(Input)`
    background: white;
    margin-top: 1px;
    font-size: 15px;
    padding: 18px 12px 17px;
    height: 35px;
    width: 100%;
`

const Inline = styled.div`
    display: inline-block;
    vertical-align: middle;
`

const headerHeight = '90px;'

const Header = styled(Padding)`
  background: ${colors.white};
  color: ${colors.bluedarkest};
  font-size: 30px;
  font-weight: 800;
  padding: 30px;

  & span {
    vertical-align: text-bottom;
  }
`

const ExclamationIconWrapper = styled(FontAwesomeIcon)`
    margin-right: 5px;
`

const ExclamationCircleIcon = (props) => <ExclamationIconWrapper {...props} icon="exclamation-circle" />

const Unselected = styled.div`
    background: ${colors.greylightest};
    color: ${colors.grey};
    height: 100%;
    padding: 15px;
`

const ShadowColumn = styled(Column)`
    box-shadow: -1px 0px 6px #0000002c;
    overflow: hidden;
    width: 400px;

    ${({ isMobile }) => isMobile && `
        position: absolute;
        background: white;
        width: 100%;
        top: 0;
        transition: left .5s;
    `}

    ${({ isMobile, isSelected }) => isMobile && isSelected && `
        left: 0;
    `}

    ${({ isMobile, isSelected }) => isMobile && !isSelected && `
        left: 100%;
    `}
`

const CloseButton = styled(Link)`
    position: absolute;
    z-index: 10;
    font-size: 12px;
    padding: 10px 12px;
    bottom: 0;
    left: 0;
    color: ${colors.grey};
    text-decoration: none;
    font-weight: normal;
`

const PageTitle = styled.div`
    color: #092c46;
    font-size: 25px;
    font-weight: bold;
    display: inline-block;
    line-height: 25px;

    .names-separator {
        color: #75889C;
        font-weight: normal;
    }
}`

export {
    AddIcon,
    CloseButton,
    Dismiss,
    ExclamationCircleIcon,
    headerHeight,
    Header,
    HeaderBar,
    Inline,
    PageTitle,
    SearchBoxContainer,
    ShadowColumn,
    Suggestions,
    Unselected,
}
